<template>
  <div class="edit-btns" :style="{ 'flex-direction': direction || null }">
    <button class="btn edit-drag" v-if="showBtn('drag')">
      <i class="icon wiki-editable-drag"></i>
    </button>
    <!-- 更多 -->
    <button
      class="btn edit-more"
      v-if="showBtn('more')"
      @mouseenter.stop="isShowMorePanel = true"
      @mouseleave.stop="isShowMorePanel = false"
    >
      <i class="icon wiki-editable-more"></i>
      <div class="more-panel" refs="morePanel" v-show="isShowMorePanel">
        <!-- 复制 -->
        <div class="panel-item" v-if="showMoreBtn('copy')" @click="handleMore('copy')">
          复制
        </div>
        <!-- 复制到剪贴板 -->
        <div class="panel-item" v-if="showMoreBtn('copyToClipboard')" @click="handleMore('copyToClipboard')">
          复制到剪贴板
        </div>
        <!-- 一键标记数字颜色 -->
        <div
          class="panel-item"
          v-if="showMoreBtn('markEditorNumberColor')"
          @click="handleMore('markEditorNumberColor', '#ff0000')"
        >
          一键标红数字颜色
        </div>
        <div class="panel-item has-next" v-if="showMoreBtn('markEditorNumberColor')">
          一键标记数字颜色
          <div class="next-panel next-color-panel">
            <color-picker color="#fff" @pick="value => handleMore('markEditorNumberColor', value)"></color-picker>
          </div>
        </div>
      </div>
    </button>
    <!-- 设置 -->
    <button class="btn edit-setup" v-if="showBtn('setup')" @click.stop="handleSetup">
      <i class="icon wiki-editable-setup"></i>
    </button>
    <!-- 确认 -->
    <button class="btn edit-confirm" v-if="showBtn('confirm')" @click.stop="handleConfirm">
      <i class="icon wiki-editable-confirm"></i>
    </button>
    <!-- 编辑 -->
    <button class="btn edit-btn" v-if="showBtn('edit')" @click.stop="handleEdit">
      <i class="icon wiki-editable-edit"></i>
    </button>
    <!-- 删除 -->
    <button class="btn delete-btn" v-if="showBtn('delete')" @click.stop="handleDelete">
      <i class="icon wiki-editable-delete"></i>
    </button>
    <!-- 添加 -->
    <button class="btn add-btn" v-if="showBtn('add')" @click.stop="handleAdd">
      <i class="icon wiki-editable-add"></i>
    </button>
  </div>
</template>

<script>
import ColorPicker from "@/components/ColorPicker";

export default {
  name: "EditBtns",
  components: {
    ColorPicker
  },
  props: {
    editBtns: {
      type: Array,
      default: () => []
    },
    moreBtns: {
      type: Array,
      default: () => []
    },
    direction: String
  },
  data() {
    return {
      isShowMorePanel: false
    };
  },

  mounted() {},

  methods: {
    showMoreBtn(key) {
      return this.moreBtns.includes(key);
    },
    showBtn(key) {
      if (key === "more" && this.moreBtns.length > 0) {
        return true;
      }
      return this.editBtns.includes(key);
    },
    handleSetup() {
      this.isEdit = false;
      this.$emit("onSetup");
    },
    handleConfirm() {
      this.isEdit = false;
      this.$emit("onConfirm");
    },
    handleEdit() {
      this.isEdit = true;
      this.$emit("onEdit");
    },
    handleDelete() {
      this.isEdit = false;
      this.$emit("onDelete");
    },
    handleAdd() {
      this.$emit("onAdd");
    },
    handleMore(command, data) {
      this.isShowMorePanel = false;
      this.$emit("onMore", command, data);
    }
  }
};
</script>

<style lang="less" scoped>
.edit-btns {
  display: inline-flex;
  gap: 3px;
  .btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    transition: all 0.3s;
    &:hover {
      transform: scale(1.1);
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}

.more-panel {
  position: absolute;
  z-index: 111;
  left: 0;
  top: 20px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 150px;
  height: auto;
  min-height: 32px;
  border-radius: 4px;
  border: 1px solid #e3e3e3;
  box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.2);

  .has-next {
    position: relative;
    &:hover {
      .next-more-panel {
        display: flex;
      }
      .next-color-panel {
        display: flex;
      }
    }
  }
  .next-panel {
    display: none;
    position: absolute;
    z-index: 112;
    background-color: #ffffff;
    width: 120px;
    height: auto;
    right: -120px;
    border-radius: 4px;
    border: 1px solid #e3e3e3;
    box-shadow: 1px 2px 5px 2px rgba(0, 0, 0, 0.2);
  }
  .next-more-panel {
    width: 120px;
    height: auto;
    right: -120px;
    top: 0;
  }
  .next-color-panel {
    width: 300px;
    height: auto;
    left: -300px;
    top: 0;
    padding: 10px;
  }

  .panel-item {
    width: 100%;
    color: #333;
    height: 32px;
    padding: 0 20px;
    line-height: 32px;
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    &:hover {
      background-color: #e3e3e3;
    }
    &:last-child {
      border-bottom: none;
    }
  }
}
</style>
